import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="on-dark bg-[#1A1A1A] text-white pt-24 pb-28 md:pb-10 relative z-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-12 pb-20 border-b border-white/10">
          <div>
            <p className="overline text-[#B0872A] mb-4">Begin Your Ritual</p>
            <h3 className="font-display text-4xl md:text-5xl leading-tight tracking-tight">
              Book a complimentary skin consultation today.
            </h3>
            <Link to="/consultation" data-testid="footer-consultation-btn" className="btn-primary bg-white text-[#1A1A1A] mt-8">
              Free Consultation
            </Link>
          </div>
          <div className="md:pl-8">
            <p className="overline text-[#B0872A] mb-5">Explore</p>
            <ul className="space-y-3 text-white/70">
              <li><Link to="/skin-analysis" className="hover:text-white transition-colors">AI Skin Analysis</Link></li>
              <li><Link to="/shop" className="hover:text-white transition-colors">Shop Skincare</Link></li>
              <li><Link to="/consultation" className="hover:text-white transition-colors">Consultation</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-[#B0872A] mb-5">Contact</p>
            <ul className="space-y-4 text-white/70">
              <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#B0872A]" strokeWidth={1.5} /> +1 (661) 666-8041</li>
              <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#B0872A]" strokeWidth={1.5} /> Womenheaven@outlook.com</li>
              <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[#B0872A]" strokeWidth={1.5} /> Santa Clarita, California</li>
              <li><a href="https://instagram.com/womenheavenmedspa" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 hover:text-white transition-colors"><Instagram className="w-4 h-4 text-[#B0872A]" strokeWidth={1.5} /> @womenheavenmedspa</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-16 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-white/40 text-sm order-2 md:order-1">© {new Date().getFullYear()} Women Heaven. All rights reserved.</p>
          <div className="flex items-center gap-5 order-1 md:order-2 text-sm">
            <Link to="/privacy" data-testid="footer-privacy" className="text-white/60 hover:text-white transition-colors">Privacy Policy</Link>
            <span className="text-white/20">·</span>
            <Link to="/terms" data-testid="footer-terms" className="text-white/60 hover:text-white transition-colors">Terms &amp; Conditions</Link>
          </div>
          <p className="text-white/30 text-xs order-3 max-w-md text-center md:text-right">
            Cosmetic guidance only — not a medical diagnosis. Individual results vary.
          </p>
        </div>
        <h2 className="font-display text-[16vw] leading-none text-center mt-12 tracking-tight text-white/[0.06] select-none">
          Women Heaven
        </h2>
      </div>
    </footer>
  );
}
